<template>
  <!--创建EXT跟grid配对的按钮-->
  <el-dialog :title="$t('lang.editMedia')" :visible.sync="data.show" width="600px" :center="true" :close-on-click-modal="false" class="add-source-dialog" @close="cancel">
    <div class="content scrollbar">
      <div class="type">
        <div class="item">
          <span><i class="redColor">* </i>{{ $t('lang.Folder') }}</span>
          <el-input class="treeInput" v-model="flodLocation" @focus="showTree" readonly="readonly"></el-input>
          <div class="flodTree" v-if="showTreeFlag">
            <el-tree :data="mediaList" :props="mediaListProps" node-key="id" default-expand-all show-checkbox :expand-on-click-node="false" :check-on-click-node="true" ref="tree" :check-strictly="true" @check="getCheckedKeys">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span class="f_left ellipsis" :title="node.label">
                  <span class="iconfont icon-Handle f_left ellipsis" style="color: #33ab4f" v-if="data.folderName ? true : false"></span>
                  {{ node.label }}
                </span>
              </span>
            </el-tree>
          </div>
        </div>

        <div class="item">
          <span><i class="redColor">* </i>{{ $t('lang.urlPath') }}</span>
          <el-input v-model.trim="params.url" autocomplete="off" size="small" :maxlength="255" :placeholder="$t('lang.urlPathRequired')"></el-input>
        </div>
        <div class="item">
          <span><i class="redColor">* </i>{{ $t('lang.name') }}</span>
          <el-input v-model.trim="params.name" autocomplete="off" size="small" :maxlength="125" :placeholder="$t('lang.eventName')"></el-input>
        </div>
        <div class="item" v-if="false">
          <span class="item_title"><i class="redColor">* </i>
            {{ $t('lang.houseIdTitle') }}
          </span>
          <el-input v-model.trim="params.houseId" autocomplete="off" size="small" :maxlength="125" placeholder=""></el-input>
        </div>

        <div class="item">
          <span class="item_title"><i class="redColor">* </i>
            {{ $t('lang.setType') }}
          </span>
          <el-select v-model="params.setType" placeholder=" " popper-class="selectMediaList">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              <span :class="selectClass(item.value)"></span>
              <span style="float: left; color: #8492a6; font-size: 13px">{{
                item.label
              }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <span>{{ $t('lang.remark') }}</span>
          <el-input v-model.trim="params.remark" autocomplete="off" size="small" :maxlength="125" :placeholder="$t('lang.description')"></el-input>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel" @click="cancel">{{ $t('lang.cancel') }}</el-button>
      <el-button class="save" :loading="editMediaLoading" v-repeat-click="{ event: save }">{{ $t('lang.save') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { scheduleAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    data: Object
  },
  data () {
    return {
      // 视频文件列表配置
      mediaListProps: {
        label: 'name',
        children: 'sonFileInfo'
      },
      name: '',
      // 查询参数
      fileParam: {
        pageNum: 1,
        pageSize: 15,
        condition: '',
        sessionId: Outil.getSession()
      },
      // 类型选项
      options: [
        {
          value: 'break',
          label: 'Break'
        },
        {
          value: 'clip',
          label: 'Clip'
        }
      ],
      // 编辑文件信息
      params: {
        url: '',
        name: '',
        remark: '',
        clipId: '',
        houseId: '',
        folderName: '',
        setType: 'break'
      },
      // 选中文件夹的名字
      flodLocation: '',
      // 文件夹选则开关
      showTreeFlag: false,
      // 文件夹列表
      mediaList: [],
      // 文件夹信息
      objctKey: {},
      // 是否在使用
      isUsing: '',
      // 编辑Loading
      editMediaLoading: false
    }
  },
  mounted () {
    document.addEventListener('click', this.clickFolderSelect)
    this.params = {
      ...this.data
    }
    this.objctKey.id = this.data.parentId
    this.showList()
  },
  components: {},
  created () {
    this.checkFileInUse()
  },
  methods: {
    // 判断点击位置
    clickFolderSelect (event) {
      if (
        !(
          $('.flodTree')[0] == event.target ||
          ($('.flodTree')[0] && $('.flodTree')[0].contains(event.target)) ||
          $('.treeInput')[0] == event.target ||
          ($('.treeInput')[0] && $('.treeInput')[0].contains(event.target))
        )
      ) {
        this.showTreeFlag = false
      }
    },
    // 检查文件是否被使用
    checkFileInUse () {
      const params = {
        isDirectory: !this.data.directory,
        fileId: this.data.id,
        objectKey: this.data.objectKey,
        bucketCode: this.$BehaviorSyns.getRegionBucket('bucket'),
        sourceId: this.data.sourceId
      }
      const url = Outil.getUrl('/playoutfolderNew/checkFileInUse')
      this.axios
        .post(url, params)
        .then(res => {
          if (res.data.errorCode == '0x0') {
            if (!res.data.result.length) {
              this.isUsing = 'Not in use'
            }
          } else if (res.data.errorCode == '806022022') {
            this.isUsing = 'Be using'
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.isUsing = errorInfo
          }
        })
        .catch(() => { })
    },
    // 显示文件夹树
    showTree () {
      this.showTreeFlag = true
      this.$nextTick(() => {
        this.$refs.tree.setChecked(this.objctKey.id, true)
      })
    },
    // 点击复选框时
    getCheckedKeys (current, checked) {
      let isChoose = false
      checked.checkedKeys.forEach(item => {
        if (item != current.id) {
          this.$refs.tree.setChecked(item, false)
        } else {
          isChoose = true
        }
      })
      if (isChoose) {
        this.flodLocation = current.name
        this.objctKey = current
      } else {
        this.flodLocation = ''
        this.objctKey = {}
      }
    },
    // 获取文件夹列表
    showList () {
      const programId = this.$BehaviorSyns.getProgramId()
      if (!programId) {
        return
      }
      const url = '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/getFolders'
      const fileParam = {
        pageNum: 1,
        pageSize: 1000,
        bucketCode: this.$BehaviorSyns.getRegionBucket('bucket'),
        queryRgion: true,
        programId: programId,
        all: false
      }
      this.axios
        .post(url, fileParam, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        })
        .then(res => {
          if (res.data.errorCode == '0x0') {
            if (res.data.result.length > 0) {
              const folderList = res.data.result
              // const folderList = this.FilterFolder(res.data.result)
              this.mediaList = folderList
              for (let i = 0; i < this.mediaList.length; i++) {
                const item = this.mediaList[i]
                if (item.id == this.objctKey.id) {
                  this.flodLocation = item.name
                  break
                }
                if (this.recursionQuery(item)) {
                  break
                }
              }
            }
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => { })
    },
    // 过滤文件夹
    FilterFolder (folderList) {
      let FileList = []
      const ProgramRMessage = Outil.getProgramReceiver()
      let showFolders
      if (ProgramRMessage) {
        showFolders = ProgramRMessage.showFolders
      }
      if (showFolders) {
        showFolders = showFolders.toUpperCase()
        const folderNameList = showFolders.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter(item =>
          folderNameList.includes(item.name.toUpperCase())
        )
        return FileList
      }
      const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
      if (urlInfo.folderNameList) {
        const folderName = urlInfo.folderNameList.toUpperCase()
        const folderNameList = folderName.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter(item =>
          folderNameList.includes(item.name.toUpperCase())
        )
      }
      return FileList
    },
    // 递归查询文件夹名字
    recursionQuery (item) {
      if (item.sonFileInfo.length > 0) {
        for (let i = 0; i < item.sonFileInfo.length; i++) {
          const item1 = item.sonFileInfo[i]
          if (item1.id == this.objctKey.id) {
            this.flodLocation = item1.name
            break
          }
          if (this.recursionQuery(item1)) {
            break
          }
        }
      }
      if (this.flodLocation) {
        return true
      }
    },
    // 保存
    save () {
      // mySourceAnalyze('mySourceSaveExt', this.$route.path);    // 谷歌统计
      if (this.isUsing == 'Not in use') {
        this.saveData()
      } else if (this.isUsing == 'Be using') {
        if (this.data.name != this.params.name) {
          this.$message.info(this.$t('lang.fileForbidRenaming'))
        } else {
          this.saveData()
        }
      } else {
        this.$message.error(this.isUsing)
      }
    },
    // 保存接口
    saveData () {
      const data = {
        clipId: this.params.clipId,
        folderId: this.objctKey.id ? this.objctKey.id : '',
        name: this.params.name,
        remark: this.params.remark,
        setType: this.params.setType,
        url: this.params.url,
        fileId: this.params.id,
        operationType: 'edit'
      }
      if (data.name.indexOf('/') >= 0) {
        this.$message.error(`"/" ${this.$t('lang.notAllowedFileName')}`)
        return
      }
      data.md5Id = this.data.fileMD5Id
      this.editMediaLoading = true
      this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/fileInfoNew/update', data, {
          contentType: 'application/json;charset=UTF-8'
        })
        .then(res => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            this.clear()
            this.data.show = false
            if (this.objctKey.id != this.data.parentId) {
              this.$emit('queryFile', 'compile')
            } else {
              this.$emit('queryFile')
            }
            scheduleAnalyze('schedulerFileAdd', '/po')
          } else if (res.data.errorCode == '81000801') {
            this.$message({
              type: 'warning',
              message: this.$t('lang.bookingEditFail')
            })
            this.editMediaLoading = false
          } else {
            this.editMediaLoading = false
            Outil.ToTip(res.data.errorCode, 'error', res.data.errorInfo)
          }
        })
        .catch(() => { })
    },
    clear () {
      this.url = ''
      this.name = ''
      this.code = ''
      this.self = ''
    },
    cancel () {
      this.clear()
      this.data.show = false
    },
    // clip选项的颜色
    selectClass (i) {
      if (i == 'clip') {
        return 'yellow'
      } else {
        return 'zise'
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.clickFolderSelect)
  }
}
</script>
<style lang="less" scoped>
.add-source-dialog {
  top: -40px;
  .scrollbar {
    overflow-x: hidden;
  }

  .content {
    text-align: left;
    font-size: 16px;
    /*max-height: 55vh;*/
    height: 500px;
    overflow-y: auto;

    .item {
      /*margin-bottom: 10px;*/

      &:last-child {
        margin-bottom: 0;
      }

      span {
        display: block;
        line-height: 50px;
        /*margin-bottom: 5px;*/
      }
    }

    ::v-deep .el-input .el-input__inner {
      border: 1px solid #444;
      background: #444;
      color: white !important;

      &::-webkit-input-placeholder {
        color: #666;
      }
    }

    ::v-deep .select-box {
      width: 100%;

      .el-input__inner {
        border: 1px solid #444;
        background: #444;
      }
    }

    ::v-deep .el-select {
      width: 100%;

      .el-select__input {
        color: #fff;
      }
    }

    ::v-deep .selectRlist {
      width: 100%;
      height: 300px;
      overflow-y: auto;
    }
    ::v-deep .el-input {
      width: 100%;
    }
  }
  ::v-deep .el-dialog__footer {
    padding: 10px;
  }
}

.delete {
  width: 120px;
}
.yellow {
  background: #ffc573;
  float: left;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin-top: 6px;
  margin-right: 10px;
}
.zise {
  background: #9248c7;
  float: left;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin-top: 6px;
  margin-right: 10px;
}
.flodTree {
  width: 510px;
  height: 410px;
  background: #444;
  position: absolute;
  z-index: 9999;
  border-radius: 2px;
  overflow-y: auto;
  ::v-deep.el-tree-node__content > .el-tree-node__expand-icon {
    padding: 1px;
  }
  ::v-deep.el-tree-node__content {
    height: 30px;
    line-height: 30px;
  }
  ::v-deep.el-checkbox {
    margin-bottom: 0px !important;
    margin-right: 5px !important;
  }
}
</style>
